import { TFunction } from 'i18next';
import { DailyFilter } from './types';

export function dailyFilterDescriptor(filter: DailyFilter, t: TFunction): string {
  switch (filter) {
    case 'office':
      return t('whereabouts-v2.filter-descriptor-office', 'in the office');
    case 'workingElsewhere':
      return t('whereabouts-v2.filter-descriptor-working-elsewhere', 'working elsewhere');
    case 'outOfOffice':
      return t('whereabouts-v2.filter-descriptor-out-of-office', 'out of office');
    default:
      return '';
  }
}
